import "./App.css";
import Router from "./views/router/Router";
function App() {
  return (
    <div>
      <Router />
    </div>
  );
}

export default App;
